<template>
    <div class="p-4 bg-gray-50 border border-gray-200 rounded-xl">
        <ui-form-section class="mb-4">
            <template v-if="equipment.inUse">
                <ui-date-picker label="Date In" name="dateIn" :error="form.errors.get('dateIn')" v-model="form.dateIn"
                                placeholder="In Date..." class="xl:col-span-6"></ui-date-picker>
                <ui-input label="Condition In" name="conditionIn" :error="form.errors.get('conditionIn')"
                          v-model="form.conditionIn" class="xl:col-span-6"></ui-input>
            </template>
            <template v-else>
                <ui-select-searchable
                    label="Package"
                    placeholder="This equipment is being booked out to..."
                    v-model="form.package"
                    :error="form.errors.get('packageReference')"
                    :search="searchPackages"
                    no-search="Start typing to find packages..."
                    class="xl:col-span-6"
                ></ui-select-searchable>
                <ui-select-searchable
                    label="Contact"
                    placeholder="This work is being booked out to..."
                    v-model="form.contact"
                    :error="form.errors.get('contact')"
                    :search="searchSuppliers"
                    no-search="Start typing to find people or companies..."
                    class="xl:col-span-6"
                ></ui-select-searchable>
                <ui-date-picker label="Date Out" name="out" :error="form.errors.get('dateOut')" v-model="form.dateOut"
                                placeholder="Out Date..." class="xl:col-span-6"></ui-date-picker>
                <ui-input label="Condition Out" name="conditionOut" :error="form.errors.get('conditionOut')"
                          v-model="form.conditionOut" class="xl:col-span-6"></ui-input>
            </template>
        </ui-form-section>
        <div class="flex justify-end space-x-4">
            <ui-button-new primary @click.prevent="form.submit()" :loading="form.busy">Add Usage Entry</ui-button-new>
        </div>
    </div>
</template>

<script>
import {Package, Supplier} from '@models'

export default {
    props: {
        equipment: Object,
    },
    data() {
        return {
            form: new Form({}, async (form) => {
                try {
                    let data = form.export()
                    data.isReturning = this.equipment.inUse
                    await this.equipment.addUsage(data)
                    await this.equipment.refresh()
                    form.reset()

                } catch (error) {

                    if (error.message === 'Date In must be supplied') {
                        this.form.errors.errors.dateIn = '"Date In" is required'
                    } else if (error.message === 'Date Out must be supplied') {
                        this.form.errors.errors.dateOut = '"Date Out" is required'
                    } else if (error.message === 'Contact must be supplied') {
                        this.form.errors.errors.contact = 'Contact name is required'
                    }
                }
            }),
        }
    },
    methods: {
        async searchPackages(query) {
            return await Package.search(query, true)
        },
        async searchSuppliers(query) {
            return (await Supplier.search(query)).map(x => x.toDropdown())
        },
    },
}
</script>
